'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const focusableNodeSelector = [
  "a[href]",
  "button",
  "input",
  "textarea",
  "select",
  "details",
  "[tabindex]"
].join(", ");
const enabledSelector = ':not([disabled]):not([tabindex="-1"])';
const findFocusableNodesWithin = (contextNode) => {
  return Array.from(contextNode.querySelectorAll(focusableNodeSelector)).filter((node) => {
    return node.matches(enabledSelector);
  });
};
const findModalNodeToFocus = (modalNode, focusTarget) => {
  const allFocusableNodes = findFocusableNodesWithin(document);
  const focusableNodesWithinModal = findFocusableNodesWithin(modalNode);
  const firstFocusableModalNode = focusableNodesWithinModal[0];
  const lastFocusableModalNode = focusableNodesWithinModal[focusableNodesWithinModal.length - 1];
  if (!firstFocusableModalNode) {
    return void 0;
  }
  const focusTargetIndex = allFocusableNodes.indexOf(focusTarget);
  const firstFocusableModalNodeIndex = allFocusableNodes.indexOf(firstFocusableModalNode);
  return focusTargetIndex < firstFocusableModalNodeIndex ? lastFocusableModalNode : firstFocusableModalNode;
};
const useFocusTrap = (modalRef) => {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    if (!hasMounted && modalRef.current) {
      const firstFocusableModalNode = findFocusableNodesWithin(modalRef.current)[0];
      if (firstFocusableModalNode) {
        firstFocusableModalNode.focus();
      }
      setHasMounted(true);
    }
    const onFocusIn = (e) => {
      const focusTarget = e.target;
      const modalNode = modalRef.current;
      if (focusTarget && modalNode && !modalNode.contains(focusTarget)) {
        const modalNodeToFocus = findModalNodeToFocus(modalNode, focusTarget);
        if (modalNodeToFocus) {
          modalNodeToFocus.focus();
        }
      }
    };
    document.addEventListener("focusin", onFocusIn);
    return () => {
      document.removeEventListener("focusin", onFocusIn);
    };
  }, [hasMounted, setHasMounted, modalRef]);
};

exports.useFocusTrap = useFocusTrap;
//# sourceMappingURL=useFocusTrap.cjs.js.map
